var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.showDetail,
        width: "900px",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.showDetail = $event
        },
        closed: function ($event) {
          return _vm.$emit("closed")
        },
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v("系统公告"),
      ]),
      _c("div", { staticClass: "container" }, [
        _c("img", { staticClass: "image", attrs: { src: _vm.url } }),
        _c("div", [
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.message.header)),
          ]),
          _c("p", { staticClass: "time" }, [
            _vm._v(
              _vm._s(
                _vm.moment(_vm.message.pushTime).format("YYYY-MM-DD HH:mm:ss")
              )
            ),
          ]),
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(
              _vm.message.message ? _vm.message.message.split("\n") : [],
              function (item, index) {
                return _c("div", { key: index }, [
                  _vm._v(" " + _vm._s(item) + " "),
                ])
              }
            ),
            0
          ),
        ]),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.showDetail = false
                },
              },
            },
            [_vm._v("我知道了")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }